import { render } from "./NoImpactResult.vue?vue&type=template&id=74f99f7a&scoped=true"
import script from "./NoImpactResult.vue?vue&type=script&lang=js"
export * from "./NoImpactResult.vue?vue&type=script&lang=js"

import "./NoImpactResult.vue?vue&type=style&index=0&id=74f99f7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f99f7a"]])

export default __exports__